import MdTable from "../Components/MdTable/MdTable";
import MdLink from "../Components/MdLink/MdLink";
import MdBlockQuote from "../Components/MdBlockQuote/MdBlockQuote";

export default {
  table: MdTable,
  link: MdLink,
  blockquote: MdBlockQuote
};
